import _ from 'lodash';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, ContentContainer } from '../shared/styles';
import Actions from './content-format-type-components/actions';
import useContentFormatTypesStore from './content-format-type-components/state-hook';
import { useGetContentFormatTypes } from '../../../services/lwadmin/content-format-type/content-format-type-service';
import Loading from '../../../shared/loading';
import Header from './content-format-type-components/header';
import ContentFormatType from './content-format-type-components/content-format-type';

export default function ContentFormatTypes() {
  const set = useContentFormatTypesStore(state => state.set);
  const contentFormatTypes = useContentFormatTypesStore(state => state.contentFormatTypes);
  const [{ loading }, get] = useGetContentFormatTypes();
  const loadingRef = React.useRef();

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => {
      set(state => {
        state.contentFormatTypes = _.get(data, 'contentFormatTypes', []);
      });
    });
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Content Format Types</h1>
          <Header />
          <Loading ref={loadingRef}>
            {contentFormatTypes.map(cft => (
              <ContentFormatType
                key={cft.id}
                contentFormatType={cft}
              />
            ))}
          </Loading>
        </ContentContainer>
        <Actions />
      </Container>
    </ThemeProvider>
  );
}
